import React, { createContext, useContext, ReactNode, useCallback, useState } from 'react';

// Define the context type
type AppBarContextType = {
    title: string;
    parentRoute: string | null;
    setHeader: (title: string, parentRoute: string | null) => void;
};

// Create the context with a default value
const AppBarContext = createContext<AppBarContextType | undefined>(undefined);

// Context provider component
export const AppBarProvider = ({ children }: { children: ReactNode }) => {
    const [title, setTitle] = useState<string>(''); // Local state to store the title
    const [parentRoute, setParentRoute] = useState<string | null>(null);

    const setHeader = (title: string, parentRoute: string | null) => {
        setTitle(title);
        setParentRoute(parentRoute);
    };

    return (
        <AppBarContext.Provider value={{ title, parentRoute, setHeader }}>
            {children}
        </AppBarContext.Provider>
    );
};
// Custom hook to use the context
export const useAppBar = () => {
    const context = useContext(AppBarContext);
    if (!context) {
        throw new Error('useAppBarTitle must be used within an AppBarTitleProvider');
    }
    return context;
};